import { Route } from 'react-router-dom';

import commonRoutes from './commonRoutes';
import ProtectedRoute from './ProtectedRoute';
import publicRoutes from './publicRoutes';

export default (
  <>
    <Route element={<ProtectedRoute />}>{publicRoutes}</Route>
    {commonRoutes}
  </>
);
